export class IngestionPartition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "pipelineId",
            "baseName": "pipelineId",
            "type": "string",
            "format": ""
        },
        {
            "name": "partitionValue",
            "baseName": "partitionValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "partitionValueHash",
            "baseName": "partitionValueHash",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "IngestionPartitionStatus",
            "format": ""
        },
        {
            "name": "topicId",
            "baseName": "topicId",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "failureMessage",
            "baseName": "failureMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstSeenAt",
            "baseName": "firstSeenAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastSeenAt",
            "baseName": "lastSeenAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPartition.attributeTypeMap;
    }
    constructor() {
    }
}
